import angular from 'angular';
import { InsuranceConfig } from './insurance.config';

export const InsuranceStepModule = angular
  .module('app.steps.insurance', [])
  .config(InsuranceConfig);
